import { Avatar, styled } from "@mui/material";

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
	backgroundColor: theme.palette.grey[300],
	width: 90,
	height: 90,
}));
